// extracted by mini-css-extract-plugin
module.exports = {"backgroundShade":"BackgroundShade_backgroundShade__KJgsr"};